app.directive('progressTracker', ["$timeout", function($timeout) {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    scope: {
      'src': '='
    },
    templateUrl: '../modules/progressTracker/views/progressTracker.html',
    link: function($scope, element) {
      $timeout(function(){
        $scope.src.directiveLinked(element);
      },20);

        $scope.$on('$destroy', () => {
            $scope.src.directiveDestroyed(element);
        });
    }
  }
}]);
